import type { ConnectionTarget } from "./model.ts";

/** One Environment Service registration supplied to the client runtime. */
export interface HostEnvironmentRegistration {
  readonly target: ConnectionTarget;
  /**
   * Whether this Environment may connect, as the platform's own persistence remembers it.
   * Absent means yes. The platform decides, because the platform is what outlives a restart;
   * a live toggle still wins over a re-registration for as long as the entry is registered.
   */
  readonly enabled?: boolean;
}

/** Runtime entry for a registered Environment Service. */
export interface HostEnvironmentEntry extends HostEnvironmentRegistration {
  /**
   * False when the user switched this Environment off. It stays registered and keeps its
   * credentials and cached data; what it loses is the socket and the retry ladder.
   *
   * This is not a weaker form of removal. Removing is the user saying they no longer want this
   * computer reachable from here at all; switching off is them saying "not right now", which has
   * to be undoable without adding the computer again.
   */
  readonly enabled: boolean;
}

export function hostEnvironmentEntry(
  registration: HostEnvironmentRegistration,
  options?: { readonly enabled?: boolean },
): HostEnvironmentEntry {
  return { ...registration, enabled: options?.enabled ?? registration.enabled ?? true };
}
